var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Dependencies, Layout, Auth } from "~/core/decorator";
import { Getter, namespace, State } from "vuex-class";
import { PageService } from "~/utils/page.service";
import { SortService } from "~/utils/sort.service";
import SelectDepartment from "~/components/business-component/select-department.vue";
import NumberRange from "~/components/common/number-range.vue";
import { LegalCaseManageService } from "~/services/domain-service/legal-case-manage.service";
import CaseAllot from "~/components/distribution-common/case-allot.vue";
import Apply from "~/components/visit-case/apply.vue";
import { ApplyType, CASE_CHANNEL, MENU_CHANNEL } from "~/config/enum.config";
import GetLabelName from "~/components/labeling-strategy/get-label-name.vue";
import PrincipalRecovery from "~/components/apply-component/principal-recovery.vue";
var CollectionExecutionModule = namespace("collection-execution");
var AllotModule = namespace("case-allot");
var LegalStopCaseManage = /** @class */ (function (_super) {
    __extends(LegalStopCaseManage, _super);
    function LegalStopCaseManage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.caseChannel = CASE_CHANNEL.legal;
        _this.model = {
            caseNumber: "",
            personalName: "",
            mobileNo: "",
            idCard: "",
            overdueAmount: {
                max: "",
                min: ""
            },
            loanDate: [],
            principalId: '',
            partCollectionRemainingDays: { min: '', max: '' },
            personalCollectionRemainingDays: { min: '', max: '' },
            bankName: '',
            businessAddress: '',
            boardAddress: '',
            carNo: '',
            dataFromSource: '',
            followInTime: [],
            deptId: '',
            currentCollectorRealName: '',
            pauseTime: [],
            partnerName: '',
            batchNumber: ''
        };
        _this.dialog = {
            ManualDivision: false,
            apply: false,
            principalRecovery: false
        };
        _this.rules = {};
        _this.dataSet = [];
        _this.selectionList = [];
        _this.applyType = ApplyType.active;
        return _this;
    }
    LegalStopCaseManage.prototype.created = function () {
        this.refreshData();
    };
    LegalStopCaseManage.prototype.refreshData = function () {
        var _this = this;
        this.legallyCaseManageServiceTestH
            .pauseCasePool(this.paramsHandler(), this.pageService, this.sortService)
            .subscribe(function (data) {
            _this.dataSet = data;
            _this.selectionList = [];
        });
    };
    LegalStopCaseManage.prototype.paramsHandler = function () {
        var params = __assign({}, this.model);
        params.overdueAmountMax = this.model.overdueAmount ? this.model.overdueAmount.max : "";
        params.overdueAmountMin = this.model.overdueAmount ? this.model.overdueAmount.min : "";
        params.partCollectionRemainingDaysMax = params.partCollectionRemainingDays ? this.model.partCollectionRemainingDays.max : "";
        params.partCollectionRemainingDaysMin = params.partCollectionRemainingDays ? this.model.partCollectionRemainingDays.min : "";
        params.personalCollectionRemainingDaysMax = params.personalCollectionRemainingDays ? this.model.personalCollectionRemainingDays.max : "";
        params.personalCollectionRemainingDaysMin = params.personalCollectionRemainingDays ? this.model.personalCollectionRemainingDays.min : "";
        params.followInTimeMin = this.model.followInTime.length ? this.$filter.dateTimeFormat(this.model.followInTime[0]) : '';
        params.followInTimeMax = this.model.followInTime.length ? this.$filter.dateTimeFormat(this.model.followInTime[1]) : '';
        params.loanDateMin = this.$filter.dateRanageFormat(this.model.loanDate).start;
        params.loanDateMax = this.$filter.dateRanageFormat(this.model.loanDate).end;
        params.pauseTimeMin = this.model.pauseTime.length ? this.$filter.dateTimeFormat(this.model.pauseTime[0]) : '';
        params.pauseTimeMax = this.model.pauseTime.length ? this.$filter.dateTimeFormat(this.model.pauseTime[1]) : '';
        delete params.overdueAmount;
        delete params.partCollectionRemainingDays;
        delete params.personalCollectionRemainingDays;
        delete params.followInTime;
        delete params.loanDate;
        delete params.pauseTime;
        return params;
    };
    /**
     * 表单范围输入框重置
     */
    LegalStopCaseManage.prototype.handleResetForm = function () {
        this.model.overdueAmount = { min: "", max: "" };
        this.model.partCollectionRemainingDays = { min: '', max: '' };
    };
    /**
     * 重新分案
     */
    LegalStopCaseManage.prototype.manualDivision = function () {
        if (this.selectionList.length === 0) {
            this.$message.info("请选择要分配的案件");
            return;
        }
        var currentDate = new Date();
        var findBeforFlag = this.selectionList.some(function (x) { return x.pauseDueTime && x.pauseDueTime > currentDate; });
        if (findBeforFlag) {
            this.$message("您选择的案件中含有未到期案件，不能重新分案");
            return;
        }
        this.updateCaseIds(this.selectionList.map(function (v) { return v.id; }));
        this.dialog.ManualDivision = true;
    };
    LegalStopCaseManage.prototype.activeClick = function () {
        if (this.selectionList.length === 0) {
            this.$message("\u8BF7\u9009\u62E9\u8981" + this.applyType.name + "\u7684\u6848\u4EF6");
            return;
        }
        this.dialog.apply = true;
    };
    Object.defineProperty(LegalStopCaseManage.prototype, "selectedCaseIds", {
        get: function () {
            return this.selectionList.map(function (v) { return v.id; });
        },
        enumerable: false,
        configurable: true
    });
    /**
     * 进入查看执行页
     */
    LegalStopCaseManage.prototype.openExecutionPage = function (row) {
        this.$router.openCaseDetail(row.id, {
            menuChannel: MENU_CHANNEL.Legal_closed,
            hiddenCaseList: true,
            hiddenAction: true
        });
    };
    LegalStopCaseManage.prototype.departemntChange = function (id, code) { };
    /**
     * 委托方回收
     */
    LegalStopCaseManage.prototype.dealManualPartReturnCase = function () {
        if (this.selectionList.length !== 0) {
            this.dialog.principalRecovery = true;
        }
        else {
            this.$message("\u8BF7\u9009\u62E9\u8981\u8FDB\u884C\u59D4\u6258\u65B9\u56DE\u6536\u7684\u6848\u4EF6");
        }
    };
    __decorate([
        Dependencies(PageService)
    ], LegalStopCaseManage.prototype, "pageService", void 0);
    __decorate([
        Dependencies(SortService)
    ], LegalStopCaseManage.prototype, "sortService", void 0);
    __decorate([
        Dependencies(LegalCaseManageService)
    ], LegalStopCaseManage.prototype, "legallyCaseManageServiceTestH", void 0);
    __decorate([
        Getter
    ], LegalStopCaseManage.prototype, "callDepartmentData", void 0);
    __decorate([
        AllotModule.Mutation
    ], LegalStopCaseManage.prototype, "updateCaseIds", void 0);
    __decorate([
        State
    ], LegalStopCaseManage.prototype, "principalList", void 0);
    LegalStopCaseManage = __decorate([
        Auth(307),
        Layout("workspace"),
        Component({
            components: {
                NumberRange: NumberRange,
                CaseAllot: CaseAllot,
                Apply: Apply,
                GetLabelName: GetLabelName,
                SelectDepartment: SelectDepartment,
                PrincipalRecovery: PrincipalRecovery
            }
        })
    ], LegalStopCaseManage);
    return LegalStopCaseManage;
}(Vue));
export default LegalStopCaseManage;
